type Truthy<T> = T extends '' | 0 | false | null | undefined ? never : T

export const allObjectValuesAreTruthy = <T extends object>(
  obj: T
): obj is { [K in keyof T]: Truthy<T[K]> } => {
  return Object.values(obj).every(Boolean)
}